(function () {

  // --- Slider navigation ---

  function initSlider(container) {
    const scroll = container.querySelector('.color-options__scroll');
    if (!scroll || container.dataset.sliderInit) return;
    container.dataset.sliderInit = '1';

    function updateNav() {
      container.classList.toggle('has-prev', scroll.scrollLeft > 0);
      container.classList.toggle('has-next', scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth - 1);
    }

    scroll.addEventListener('scroll', updateNav, { passive: true });
    requestAnimationFrame(updateNav);

    container.querySelector('.color-options__nav--prev')?.addEventListener('click', (e) => {
      e.stopPropagation();
      scroll.scrollBy({ left: -120, behavior: 'smooth' });
    });
    container.querySelector('.color-options__nav--next')?.addEventListener('click', (e) => {
      e.stopPropagation();
      scroll.scrollBy({ left: 120, behavior: 'smooth' });
    });
  }

  function initAllSliders() {
    document.querySelectorAll('.color-options--image').forEach(initSlider);
  }

  // --- ABTasty activation ---
  // Call window.ryz162.activate() from the ABTasty variation code

  window.ryz162 = {
    activate: function () {
      document.body.classList.add('ryz-162');
      initAllSliders();
    }
  };

  // --- Image swap on colour click ---

  document.addEventListener('click', (e) => {
    if (!document.body.classList.contains('ryz-162')) return;

    const el = e.target.closest('.color-options__element--image[data-primary-src]');
    if (!el) return;

    const card = el.closest('.card-wrapper');
    if (!card) return;

    const primaryImg = card.querySelector('.card__media .media img:not(.hover-image)');
    if (primaryImg && el.dataset.primarySrc) {
      el.classList.add('is-loading');
      const onLoaded = () => el.classList.remove('is-loading');
      primaryImg.addEventListener('load', onLoaded, { once: true });
      primaryImg.addEventListener('error', onLoaded, { once: true });
      primaryImg.src = el.dataset.primarySrc;
      if (el.dataset.primarySrcset) primaryImg.srcset = el.dataset.primarySrcset;
    }

    const secondaryImg = card.querySelector('.card__media .media .hover-image');
    if (secondaryImg && el.dataset.secondarySrc) {
      secondaryImg.dataset.src = el.dataset.secondarySrc;
      secondaryImg.src = el.dataset.secondarySrc;
      if (el.dataset.secondarySrcset) {
        secondaryImg.dataset.srcset = el.dataset.secondarySrcset;
        secondaryImg.srcset = el.dataset.secondarySrcset;
      }
    }

    card.querySelectorAll('.color-options__element--image').forEach((sib) => {
      sib.removeAttribute('data-active');
      sib.classList.remove('is-active');
    });
    el.setAttribute('data-active', 'true');
    el.classList.add('is-active');
  });

  // Re-init when product grid updates (filters / pagination)
  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('#product-grid, .product-grid');
    if (grid) {
      new MutationObserver(() => {
        if (document.body.classList.contains('ryz-162')) initAllSliders();
      }).observe(grid, { childList: true, subtree: true });
    }
  });

})();
